import { Badge } from "../components/ui/badge";

const STYLES = {
  Nuova: "bg-[#EFF6FF] text-[#1D4ED8] border-[#BFDBFE]",
  Affidata: "bg-[#EEF2FF] text-[#4338CA] border-[#C7D2FE]",
  "In lavorazione": "bg-[#FEF9C3] text-[#A16207] border-[#FEF08A]",
  Eseguito: "bg-[#F0FDF4] text-[#15803D] border-[#BBF7D0]",
  Chiusa: "bg-[#F3F4F6] text-[#374151] border-[#E5E7EB]",
  Annullata: "bg-[#FEF2F2] text-[#991B1B] border-[#FECACA]",
};

export function StatusBadge({ stato, size }) {
  const sm = size === "sm";
  return (
    <span
      data-testid={`status-badge-${stato}`}
      className={`inline-flex items-center font-bold uppercase tracking-wide rounded-full ${sm ? "px-2 py-0.5 text-[11px] border" : "px-3 py-1.5 text-sm border-2"} ${STYLES[stato] || STYLES.Annullata}`}
    >
      {stato}
    </span>
  );
}

export function UrgenzaBadge({ urgenza }) {
  const urgent = urgenza === "Urgente";
  return (
    <span
      className={`inline-flex items-center px-3 py-1.5 text-sm font-bold uppercase tracking-wide rounded-full border-2 ${
        urgent ? "bg-red-100 text-red-800 border-red-300" : "bg-slate-100 text-slate-700 border-slate-300"
      }`}
    >
      {urgenza}
    </span>
  );
}

const PRIORITA_STYLES = {
  Bassa: "bg-[#F1F5F9] text-[#475569] border-[#CBD5E1]",
  Media: "bg-[#FEF3C7] text-[#B45309] border-[#FDE68A]",
  Alta: "bg-[#FFEDD5] text-[#C2410C] border-[#FDBA74]",
  Critica: "bg-[#FEF2F2] text-[#B91C1C] border-[#FECACA]",
};

export function PrioritaBadge({ priorita, size }) {
  if (!priorita) return null;
  const sm = size === "sm";
  return (
    <span
      data-testid={`priorita-badge-${priorita}`}
      className={`inline-flex items-center font-bold uppercase tracking-wide rounded-full ${sm ? "px-2 py-0.5 text-[11px] border" : "px-3 py-1.5 text-sm border-2"} ${PRIORITA_STYLES[priorita] || PRIORITA_STYLES.Media}`}
    >
      {priorita}
    </span>
  );
}

export function ScadenzaBadge({ ticket }) {
  if (!ticket || (!ticket.in_ritardo && !ticket.in_scadenza)) return null;
  const scaduta = ticket.in_ritardo;
  return (
    <span
      data-testid="scadenza-badge"
      className={`inline-flex items-center px-3 py-1.5 text-sm font-bold uppercase tracking-wide rounded-full border-2 ${
        scaduta ? "bg-red-600 text-white border-red-700" : "bg-amber-100 text-amber-800 border-amber-300"
      }`}
    >
      {ticket.alert_msg}
    </span>
  );
}
